import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Subject, of } from 'rxjs';
import * as _ from 'lodash';
import moment from 'moment';
import { NgxToasterService } from '../../config/ngx-toaster.service';
import { EmpowerService } from './empower.service';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class EmpowerModernLifeService {
  environment = EnvironmentService.environment;

  // Subjects
  public modernSideNavList = new BehaviorSubject<Array<any>>([]);
  public exportComponentSubject: Subject<{ screen: number, resolved: boolean, pageIndex: number, pageTitle: string }> = new Subject();

  // Set Subject Values
  modernSetSideNavList = (value: Array<any>) => { this.modernSideNavList.next(value); };
  setExportComponentSubject = (screen: number, resolved: boolean, pageIndex: number, pageTitle: string) => { this.exportComponentSubject.next({ screen, resolved, pageIndex, pageTitle }); };

  dashboardState: any = {
    countryName: [],
    partnerName: [],
    consumerTopParent: [],
    calendarIds: []
  };

  pagesState: any = {};
  pageImgState: any = {};
  pageCommentState: any = {};

  constructor(private http: HttpClient,
    private toastr: NgxToasterService,
    private empowerService: EmpowerService) {
  }

  setPageCommentState(pageId: any, comment: any) {
    this.pageCommentState[pageId] = comment;
  }

  getPageCommentState(pageId: any): any {
    return this.pageCommentState[pageId];
  }

  setDashboardState(state: any) {
    this.dashboardState = state;
  }

  getDashboardState(): any {
    return this.dashboardState;
  }

  setPagesState(pageId: any, daxData: any) {
    this.pagesState[pageId] = daxData;
  }

  getPagesState(pageId: any) {
    return this.pagesState[pageId];
  }

  setPageImgState(pageId: any, imgFile: any) {
    this.pageImgState[pageId] = imgFile;
  }

  getPageImgState(pageId: any) {
    return this.pageImgState[pageId];
  }

  clearPagesState() {
    this.pagesState = {};
  }

  isDashboardStateValid(): boolean {
    return (this.dashboardState.countryName.length === 1
      && this.dashboardState.partnerName.length === 1
      && this.dashboardState.consumerTopParent.length === 1
      && this.dashboardState.calendarIds.length) ? true : false;
  }

  GetDashboardFilterPayload() {
    const body = this.dashboardState;
    const payload = {
      countryName: body.countryName && body.countryName.map((a: any) => `"${a}"`).join(','),
      partnerName: body.partnerName && body.partnerName.map((a: any) => `"${a}"`).join(','),
      consumerTopParent: body.consumerTopParent && body.consumerTopParent.map((a: any) => `"${a}"`).join(','),
      calendarIds: body.calendarIds && body.calendarIds.map((a: any) => moment(a).format('YYYYMMDD')).join(',')
    }
    return payload;
  }

  GetDashboardFilterPayloadForLogging() {
    const body = this.dashboardState;
    const payload = {
      countryName: body.countryName && body.countryName.join(','),
      partnerName: body.partnerName && body.partnerName.join(','),
      consumerTopParent: body.consumerTopParent && body.consumerTopParent.join(','),
      calendarIds: body.calendarIds && body.calendarIds.map((a: any) => moment(a).format('YYYYMMDD')).join(',')
    }
    return payload;
  }

  getDashboardLocation(): any {
    return _.get(this.dashboardState, 'countryName.0', '');
  }

  getDashboardPartner(): any {
    return _.get(this.dashboardState, 'partnerName.0', '');
  }

  GetSideNavMenu(reportId: any) {
    // return this.http.get<any>(`${environment.Empower}/ReportPageGetAll?reportId=${reportId}`)
    return this.http.get<any>(`${this.environment.EmpowerReport}/ReportTotalHeirarchyGetAll?ReportId=${reportId}`)
      .pipe(map(response => {
        return response[0].reportPages;
      }));
  }

  ExecutePageDaxQuery(body: any): any {
    if (this.isDashboardStateValid()) {
      return this.empowerService.ExecutePageDaxQuery(body).pipe(map(response => {
        return response;
      }));
    } else {
      this.toastr.error('Error', 'Please set dashboard filters correctly.');
      of(false);
    }
  }

}

